import React from 'react'

import { Grid } from '../Grid'
import { Flex } from '../Flex'
import { Heading } from '../Typography'

import './PageEditHeader.css'

type PageEditHeaderProps = {
  title: string
  children?: React.ReactNode
  style?: React.CSSProperties
  renderTitleActions?: () => React.ReactNode
}

export function PageEditHeader({
  title,
  children,
  style,
  renderTitleActions,
}: PageEditHeaderProps) {
  return (
    <Grid columns="1fr 320px" className="PageEditHeader" style={style}>
      <Flex justify="space-between" align="center">
        <Heading as="h1">{title}</Heading>

        <div className="PageEditHeader-titleActions">
          {renderTitleActions && renderTitleActions()}
        </div>
      </Flex>
      <Flex justify="end" gap={4}>
        {children}
      </Flex>
    </Grid>
  )
}
